import store from "@/store";
import { authApi } from "@/api";
import { message } from 'ant-design-vue'

let loadingCount = 0;
let loadingTimer = null;

const startLoading = () => {
    store.dispatch("setLoading", true);
};

const endLoading = () => {
    store.dispatch("setLoading", false);
};

export const showLoading = () => {
    clearTimeout(loadingTimer);
    loadingTimer = setTimeout(() => {
        loadingCount = 1;
        hideLoading();
    }, 300000);
    if (loadingCount === 0) {
        startLoading();
    }
    loadingCount += 1;
};

export const hideLoading = () => {
    if (loadingCount <= 0) {
        return;
    }
    loadingCount -= 1;
    if (loadingCount === 0) {
        clearTimeout(loadingTimer);
        endLoading();
    }
};

export const getCookie = (name) => {
    let cookieValue = null;
    if (document.cookie && document.cookie !== '') {
        const cookies = document.cookie.split(';');
        for (let i = 0; i < cookies.length; i++) {
            let cookie = (cookies[i] || '').trim();
            // Does this cookie string begin with the name we want?
            if (cookie.substring(0, name.length + 1) === (name + '=')) {
                cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
                break;
            }
        }
    }
    return cookieValue;
}

export const setSessionParams = (key, data) => {
    sessionStorage.setItem(key, JSON.stringify(data))
}
export const getSessionParams = (key) => {
    let data = null
    try {
        const strData = sessionStorage.getItem(key)
        if (strData) {
            data = JSON.parse(strData)
        }
    } catch (error) {

    }
    return data
}

export const creatColorByNickName = (NickName) => {
    // nick name to code
    let id = 0;
    for (var i = 0; i < NickName.length; i++) {
        id += NickName.charCodeAt(i);
    }
    id = id % 100;
    const h = id * (360 / 100);
    const s = 80;
    const l = 30;
    return hslToHex(h, s, l);
};
export const hslToHex = (h, s, l) => {
    l /= 100;
    const a = (s * Math.min(l, 1 - l)) / 100;
    const f = (n) => {
        const k = (n + h / 30) % 12;
        const color = l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
        return Math.round(255 * color)
            .toString(16)
            .padStart(2, "0"); // convert to Hex and prefix "0" if needed
    };
    return `${f(0)}${f(8)}${f(4)}`;
};

export const unique = (arr) => {
    return Array.from(new Set(arr));
}
export const uniqueObjArray = (arr, key) => {
    const map = {
        'string': e => e[key],
        'function': e => key(e),
    }
    const fn = map[typeof key]
    const obj = arr.reduce((o, e) => (o[fn(e)] = e, o), {})
    return Object.values(obj)
}
export const download = (res, downloadRef) => {
    let fileName = ''
    const disposition = res.headers['content-disposition']
    if (disposition && disposition.indexOf('attachment') !== -1) {
        // 正規表現
        const filenameRegex = /filename[^;=\n]=((['"]).*?\2|[^;\n]*)/
        const matches = filenameRegex.exec(disposition)
        if (matches != null && matches[1]) {
            // matches[1]でとれる⇒ filename*=utf-8''201911%E3%83%87%E3%83%BC%E3%82%BF.csv;
            // 不要文字列を消して、デコードしてサーバからのファイル名を取得
            fileName = decodeURI(
                matches[1].replace(/['"]/g, '').replace('UTF-8', '')
            )
        }
    }
    const fileURL = window.URL.createObjectURL(
        new Blob([res.data], { type: 'application/octet-stream' })
    )
    console.log(fileURL)
    downloadRef.value.href = fileURL
    downloadRef.value.setAttribute('download', fileName)
    downloadRef.value.click()
    window.URL.revokeObjectURL(fileURL)
}

export const blobToText = (blob) => {
    const fileReader = new FileReader();

    return new Promise((resolve, reject) => {
        fileReader.onerror = () => {
            fileReader.abort();
            reject();
        };

        fileReader.onload = () => {
            resolve(fileReader.result);
        };

        fileReader.readAsText(blob);
    });
}

export const getPrimaryKey = (visibleFields, primaryId) => {
    const field = visibleFields.find((item) => {
        return item.fieldId === primaryId
    })
    if (!field) {
        return null
    }
    return field.key
}

let putViewConfigTimer = null
export const putViewConfig = (id, cols, targetType, isAgg) => {

    clearTimeout(putViewConfigTimer)
    putViewConfigTimer = setTimeout(() => {
        const params = {
            targetType: targetType || "01",
            viewAttributions: []
        }
        if (isAgg) {
            params.aggregatedViewAttributions = []
        }
        cols.forEach((item) => {
            if (isAgg) {
                if (item.isDetailCol) {
                    params.viewAttributions.push({
                        key: item.key,
                        columnWidth: Math.round(item.width),
                    })
                } else {
                    if (item.children) {
                        // 有子集，拆子集
                        item.children.forEach((childCol) => {
                            if (childCol.width) {
                                params.aggregatedViewAttributions.push({
                                    key: childCol.key,
                                    columnWidth: Math.round(childCol.width),
                                })
                            }
                        })

                    } else if (item.width) {
                        params.aggregatedViewAttributions.push({
                            key: item.key,
                            columnWidth: Math.round(item.width),
                        })
                    }

                }
            }
            else {
                params.viewAttributions.push({
                    key: item.key,
                    columnWidth: Math.round(item.width),
                })
            }

        })
        params.viewAttributions = params.viewAttributions.filter((item) => {
            return item.key !== 'action'
        })
        authApi.putViewConfig(id, params).then(res => {
            console.log(res)
        }).catch(err => {
            console.error(err)
        })
    }, 500)

}

export const actionEdit = (id, actionHistoryId, formData) => {
    const actionType = formData.actionType
    const actionTypeId = formData.actionTypeId
    switch (actionType) {
        case '01':
            return authApi
                .putOpportunityActionHistory(actionTypeId, actionHistoryId, formData)
        case '02':
            return authApi
                .putParkingLotActionHistory(actionTypeId, actionHistoryId, formData)
        case '04':
            return authApi
                .putCompanyActionHistory(actionTypeId, actionHistoryId, formData)
        case '05':
            return authApi
                .putStaffActionHistory(actionTypeId, actionHistoryId, formData)
        default:
            break;
    }

}

export const setTitle = (title) => {
    store.dispatch('setPageTitle', title)
    document.title = title
}

export const setDefaultView = async (type, id, callback) => {
    switch (type) {
        case 'opportunity':
            await authApi.opportunityViewDefault(id).then((res) => {
                message.success('設定しました')
            })
            break;
        case 'company':
            await authApi.companyViewDefault(id).then((res) => {
                message.success('設定しました')
            })
            break;
        case 'parkinglot':
            await authApi.parkingLotViewDefault(id).then((res) => {
                message.success('設定しました')
            })
            break;
        case 'reportresult':
            await authApi.reportresultViewDefault(id).then((res) => {
                message.success('設定しました')
            })
            break;
        default:
            break;
    }
    if (callback) {
        callback()
    }
}

export const getViewPage = async (view_type) => {
    const res = await authApi.getViewPage(view_type)
    if (res.data) {
        return res.data
    }
    return 20
}
export const putViewPage = async (view_type, pageSize) => {
    await authApi.putViewPage(view_type, {
        "pageSize": pageSize
    })
}
// export const viewMapFormat = (viewMap) => {
//     const list = []
//     Object.keys(viewMap).forEach((key) => {
//         const options = viewMap[key]
//         const newOptions = []
//         options.forEach((item) => {
//             const newObj = {
//                 value: item.viewId,
//                 label: item.title,
//             }
//             if (item.viewListType === 2) {
//                 newObj.label = newObj.label + '（デフォルト）'
//             }
//             newOptions.push(newObj)
//         })
//         const obj = {
//             label: key,
//             options: newOptions
//         }
//         list.push(obj)
//     })
//     return list
// }

export const viewMapFormat = (viewMap) => {
    const list = []
    Object.keys(viewMap).forEach((key, index) => {
        const options = viewMap[key]
        const newOptions = []
        options.forEach((item) => {
            const newObj = {
                value: item.viewId,
                title: item.title,
            }
            if (item.viewListType === 2) {
                newObj.title = newObj.title + '（デフォルト）'
            }
            newOptions.push(newObj)
        })
        const obj = {
            title: key,
            selectable: false,
            value: `p${index}`,
            children: newOptions
        }
        list.push(obj)
    })
    return list
}
export const filterOption = (input, option, label) => {
    return option[label].toLowerCase().indexOf(input.toLowerCase()) >= 0;
}

export const copyStr = (str) => {
    navigator.clipboard.writeText(str).then(function () {
        /* clipboard successfully set */
        message.success('コピーしました')
    }, function () {
        /* clipboard write failed */
        message.error('コピーが失敗しました')
    });
}

// 「只解析、不执行代码」的宽松解析器，用于兼容后端返回的非严格 JSON
// （单引号 / 无引号键 / 结尾逗号等）。它不使用 eval / new Function，
// 因此不存在代码注入 / XSS 风险。
const looseJsonParse = (text) => {
    const str = String(text)
    let i = 0

    const fail = (msg) => {
        throw new SyntaxError(`looseJsonParse: ${msg} at index ${i}`)
    }

    const skipWs = () => {
        while (i < str.length && /\s/.test(str[i])) {
            i++
        }
    }

    const parseString = (quote) => {
        i++ // 跳过起始引号
        let result = ''
        while (i < str.length) {
            const c = str[i]
            if (c === '\\') {
                const next = str[i + 1]
                switch (next) {
                    case 'n': result += '\n'; i += 2; break
                    case 't': result += '\t'; i += 2; break
                    case 'r': result += '\r'; i += 2; break
                    case 'b': result += '\b'; i += 2; break
                    case 'f': result += '\f'; i += 2; break
                    case 'u': {
                        result += String.fromCharCode(parseInt(str.substr(i + 2, 4), 16))
                        i += 6
                        break
                    }
                    case 'x': {
                        result += String.fromCharCode(parseInt(str.substr(i + 2, 2), 16))
                        i += 4
                        break
                    }
                    default: result += next; i += 2
                }
            } else if (c === quote) {
                i++
                return result
            } else {
                result += c
                i++
            }
        }
        fail('unterminated string')
    }

    const parseIdentifier = () => {
        const start = i
        while (i < str.length && /[A-Za-z0-9_$]/.test(str[i])) {
            i++
        }
        if (i === start) fail('unexpected token')
        return str.slice(start, i)
    }

    const parseValue = () => {
        skipWs()
        const c = str[i]
        if (c === '{') return parseObject()
        if (c === '[') return parseArray()
        if (c === '"' || c === "'") return parseString(c)
        const rest = str.slice(i)
        if (/^true\b/.test(rest)) { i += 4; return true }
        if (/^false\b/.test(rest)) { i += 5; return false }
        if (/^null\b/.test(rest)) { i += 4; return null }
        if (/^undefined\b/.test(rest)) { i += 9; return undefined }
        const numMatch = /^-?(?:0|[1-9]\d*)(?:\.\d+)?(?:[eE][+-]?\d+)?/.exec(rest)
        if (numMatch && numMatch[0]) {
            i += numMatch[0].length
            return Number(numMatch[0])
        }
        fail('unexpected token')
    }

    const parseObject = () => {
        i++ // 跳过 {
        const obj = {}
        skipWs()
        if (str[i] === '}') { i++; return obj }
        while (i < str.length) {
            skipWs()
            const c = str[i]
            const key = (c === '"' || c === "'") ? parseString(c) : parseIdentifier()
            skipWs()
            if (str[i] !== ':') fail('expected ":"')
            i++
            obj[key] = parseValue()
            skipWs()
            if (str[i] === ',') {
                i++
                skipWs()
                if (str[i] === '}') { i++; return obj } // 结尾逗号
                continue
            }
            if (str[i] === '}') { i++; return obj }
            fail('expected "," or "}"')
        }
        fail('unterminated object')
    }

    const parseArray = () => {
        i++ // 跳过 [
        const arr = []
        skipWs()
        if (str[i] === ']') { i++; return arr }
        while (i < str.length) {
            arr.push(parseValue())
            skipWs()
            if (str[i] === ',') {
                i++
                skipWs()
                if (str[i] === ']') { i++; return arr } // 结尾逗号
                continue
            }
            if (str[i] === ']') { i++; return arr }
            fail('expected "," or "]"')
        }
        fail('unterminated array')
    }

    const result = parseValue()
    skipWs()
    if (i < str.length) fail('unexpected trailing characters')
    return result
}

// 安全地解析链接单元格字符串：优先走标准 JSON.parse，
// 失败时再用 looseJsonParse 兼容非严格 JSON，替代原先存在 XSS 风险的 eval。
export const safeJsonParse = (text) => {
    try {
        return JSON.parse(text)
    } catch (e) {
        return looseJsonParse(text)
    }
}

// 对要插入到 v-html 的用户输入进行 HTML 转义，防止 XSS 注入。
export const escapeHtml = (value) => {
    if (value === null || value === undefined) {
        return ''
    }
    const escapeMap = {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#39;',
    }
    return String(value).replace(/[&<>"']/g, (ch) => escapeMap[ch])
}
